import { deleteAssociations, saveAssociations } from '../api';
import { trackAutosaveSuccess } from '../../utils/usageTrackingUtils';
import { Metrics } from '../../metrics/Metrics';
import Raven from 'raven-js';
function getIdentifiers(batch) {
  return [...new Set(Object.keys(batch.updates))];
}
export const createAssociationEntityStrategy = httpClient => ({
  type: 'ASSOCIATION',
  createBatches(items) {
    // create one batch per item. no batching for now.
    return items.map(item => {
      const {
        request,
        onSuccess,
        onFailure,
        onUndo
      } = item.data;
      const {
        objectTypeId,
        updates
      } = request;
      const {
        associatedRecordIds
      } = updates;
      return {
        type: 'ASSOCIATION',
        objectTypeId,
        updates: associatedRecordIds,
        previousUpdates: {},
        successCallbacks: [onSuccess],
        failureCallbacks: [onFailure],
        undoCallbacks: [onUndo]
      };
    });
  },
  async save(items) {
    const batches = this.createBatches(items);
    const allResults = await Promise.allSettled(batches.map(async batch => {
      const {
        objectTypeId,
        updates
      } = batch;
      const identifiers = getIdentifiers(batch);
      const result = await saveAssociations(objectTypeId, updates, httpClient).catch(error => {
        batch.failureCallbacks.forEach(callback => callback(error));
      });
      try {
        if (result) {
          var _this$onSaveSuccess;
          trackAutosaveSuccess({
            type: 'ASSOCIATION',
            identifiers,
            objectTypeId
          });
          Metrics.counter('autosave-association-success', {
            associationCount: String(identifiers.length)
          }).increment();
          batch.successCallbacks.forEach(callback => callback(result));
          (_this$onSaveSuccess = this.onSaveSuccess) === null || _this$onSaveSuccess === void 0 || _this$onSaveSuccess.call(this, result, objectTypeId);
        }
      } catch (e) {
        Metrics.counter(`autosave-association-onsave-failure`).increment();
        Raven.captureException(new Error('Autosave association onsave failure'), {
          extra: {
            objectTypeId,
            identifiers,
            originalError: e
          }
        });
      }
      return result;
    }));
    return allResults.every(result => result.status === 'fulfilled' && result.value);
  },
  async undo(items) {
    const batches = this.createBatches(items);
    const allResults = await Promise.allSettled(batches.map(async batch => {
      const {
        objectTypeId,
        updates,
        failureCallbacks
      } = batch;
      const identifiers = getIdentifiers(batch);
      const result = await deleteAssociations(objectTypeId, updates, httpClient).catch(error => {
        failureCallbacks.forEach(callback => callback(error));
        Metrics.counter('autosave-association-undo-failure').increment();
      });
      Metrics.counter('autosave-association-undo-success').increment();
      try {
        if (result) {
          var _this$onSaveSuccess2;
          (_this$onSaveSuccess2 = this.onSaveSuccess) === null || _this$onSaveSuccess2 === void 0 || _this$onSaveSuccess2.call(this, result, objectTypeId);
          batch.undoCallbacks.forEach(callback => callback(result));
        }
      } catch (e) {
        Metrics.counter('autosave-association-undo-callback-failure').increment();
        Raven.captureException(new Error('Autosave association undo handler failed'), {
          extra: {
            objectTypeId,
            identifiers,
            originalError: e
          }
        });
      }
      return result;
    }));
    return allResults.every(result => result.status === 'fulfilled' && result.value);
  }
});